<template>
  <div class="pa-0 mt-3">
    <div @click="addListener" class="mt-6 tags">
      <v-autocomplete
        label="Enter Tag"
        v-model="modifiedTags"
        :items="dropdownTags"
        item-text="name"
        item-value="id"
        outlined
        multiple
        chips
        deletable-chips
        class="pa-0 tag-selector"
        @update:search-input="updateSearch"
        :search-input.sync="searchKeyword"
        :no-filter="true"
        @blur="searchCheck"
        attach
        :disabled="
          !ticketAccess.permissions.create ||
          ticketAccess.closed ||
          ticketAccess.deleted
        "
      >
        <template v-slot:append-item>
          <v-btn @click="newTag" text small class="pa-6">+Create new tag</v-btn>
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>

<script>
import { $tag } from "@/services/Index";

export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    ticketAccess: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dropdownTags: [],
      expansion: [0, 1],
      ticketDetails: [],
      pagination: [],
      enableScroll: true,
      page: 1,
      perPage: 10,
      selectedTags: [],
      newData: false,
      tagName: '',
      searchKeyword: null,
    };
  },

  watch: {
    searchKeyword(val) {
      this.page = 1;
      if (val && val.length > 0) {
        this.getTags();
      } else {
        this.getTags();
        this.enableScroll = true;
      }
    },
    tags(val) {
      if (this.searchKeyword === null) {
        this.getTags();
      } else {
        this.searchKeyword = null;
      }
    }
  },
  computed: {
    modifiedTags: {
      get() {
        return [...this.tags];
      },
      set(newTags) {
        this.selectedTags = this.dropdownTags.filter(item => newTags.includes(item.id));
        this.$emit('update-tags', newTags, this.selectedTags);
      }
    },
  },
  
  mounted(){
    this.getTags();
  },

  methods: {
    updateSearch(data) {
      this.tagName = data;
    },
    searchCheck() {
      this.enableScroll = true;
      if (this.searchKeyword !== null) {
        this.searchKeyword = null;
      }
    },
    async newTag() {
      let payload = {
        tag: {
          name: this.tagName,
        }
      };
      let config = {};
      this.loading = true;
      this.searchKeyword = null;
      $tag.create(payload, config).then((response) => {
        this.getTags();
        const newTag = this.modifiedTags.map((item) => item.id);
        newTag.push(response.data.id);
        const created = [...this.modifiedTags, ...[response.data]];
        this.$emit('update-tags', newTag, created);
        this.tagName = '';
        this.enableScroll = true;
        this.$store.dispatch("ui/snackbar", [
          {
            title: "New Tag",
            message: `A New Tag has been created`,
            type: "success",
          },
        ]);
      }).catch((error) => {
        this.$store.dispatch("ui/snackbar", [
          {
            title: "Error",
            message: this.$errors(error.response.data).msg({
              capitalize: false,
              prepend: `${this.$errors(error.response.data).subjectText()} `,
            }),
            type: "error",
          },
        ]);
        this.tagName = '';
      });
    },
    addListener() {
      let selectorClass = '.menuable__content__active';
      var el = document.querySelector(selectorClass);
      /** add scroll event **/
      if (el) {
        el.addEventListener('scroll', this.onScroll);
      }
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.enableScroll) {
          if (this.searchKeyword === null || this.searchKeyword === "") {
            this.getMoreTags();
          } else {
            this.getMoreTags(this.searchKeyword);
          }
        }
      }
    },
    uniqueTags() {
      const uniqueIds = [];
      this.dropdownTags = this.dropdownTags.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.id);
        if (!isDuplicate) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
    },
    trimTags() {
      this.dropdownTags.forEach(tag => {
        if (tag.name.length > 32) {
          tag.name = tag.name.substring(0, 32);
        }
      });
    },
    async getTags(searchVal = "") {
      const data = {
        per_page: this.perPage,
        page: 1,
        q: {
          name_cont: this.searchKeyword,
          m: "or",
        },
      };
      try {
        let oldTags = this.dropdownTags;
        let assignedTags = this.modifiedTags;
        const response = await $tag.fetchList(data, {});
        if (response.data) {
          this.totalItems = response.data.pagination.total_count;
          let responseTags = response.data.tag;
          if (responseTags.length === 0) {
            this.dropdownTags = [...responseTags, ...assignedTags];
          } else if (oldTags.length > 0) {
            this.dropdownTags = [...responseTags, ...oldTags];
          } else if (assignedTags.length > 0) {
            this.dropdownTags = [...responseTags, ...assignedTags, ...oldTags];
          } else {
            this.dropdownTags = responseTags;
          }
          this.uniqueTags();
          this.trimTags();
          this.loading = false;
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getMoreTags(searchVal = "") {
      ++this.page;
      const data = {
        page: this.page,
        per_page: this.perPage,
        q: {
          name_cont: searchVal,
          m: "or",
        },
      };
      try {
        const response = await $tag.fetchList(data, {});
        if (response.data) {
          this.totalItems = response.data.pagination.total_count;
          let newTags = response.data.tag;
          let tagsLength = newTags.length;
          if (tagsLength === 0) {
            this.enableScroll = false;
          } else {
            this.enableScroll = true;
            let moreTags = newTags.map((item) => {
              return {
                id: item.id,
                name: item.name,
              }
            });
            this.dropdownTags.push(...moreTags);
          }
          this.uniqueTags();
          this.trimTags();
          this.loading = false;
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
};
</script>
